/**
 * Environment variables configuration
 *
 * All environment variables must be prefixed with VITE_ to be accessible
 * in the client-side code. Access them via import.meta.env.VITE_*
 */

export const ENV = {
  // API Configuration
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL,

  // App Configuration
  DEV: import.meta.env.VITE_ENVIRONMENT === "development",
  PROD: import.meta.env.VITE_ENVIRONMENT === "production",
} as const;
